import { render, staticRenderFns } from "./Commune.vue?vue&type=template&id=7b9b79d3&"
import script from "./Commune.vue?vue&type=script&lang=js&"
export * from "./Commune.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports